namespace('compass.arctic');

compass.arctic.RefreshSessionWidget = compass.defineWidget(function RefreshSessionWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom;

	me.render = function (widgetElem) {
		widgetElem.append(
			d.h2("Your session is about to time out"),
			d.div({ className: 'refreshCopy' }, "Click okay to keep your session alive."),
			d.button({
				className: 'secondaryButton',
				role: 'button',
				'aria-role': 'button',
				tabindex: 0
			}, 'OK').activate(function () {
				me.trigger('refreshSession');
			})
		);
	};
}, {
	GUID: 'defaultRefreshSessionWidgetGUID',
	widgetName: 'RefreshSessionWidget'
});
